import type { ExecutionResult } from "./base-code-task.ts";

export class VerificationError extends Error {
    result: ExecutionResult<any>;

    constructor(result: ExecutionResult<any>, message: string = "Verification error") {
        super(message);
        this.result = result;
    }
}
